import { render, staticRenderFns } from "./privateQqbApp.vue?vue&type=template&id=2d211f2a"
import script from "./privateQqbApp.vue?vue&type=script&lang=js"
export * from "./privateQqbApp.vue?vue&type=script&lang=js"
import style0 from "./privateQqbApp.vue?vue&type=style&index=0&id=2d211f2a&prod&lang=css"
import style1 from "./privateQqbApp.vue?vue&type=style&index=1&id=2d211f2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports